import { Platform } from "react-native";

const SSRUserAgent = "rtv/ssr";

export const userAgentIsSSR = () => Platform.OS === "web" && window.navigator.userAgent === SSRUserAgent;